import { render } from "./Inspection.vue?vue&type=template&id=4813666a&scoped=true"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"

import "./Inspection.vue?vue&type=style&index=0&id=4813666a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4813666a"]])

export default __exports__